import React, { Component } from "react";
import { connect } from "react-redux";
import { Checkbox, List, ListItem, ListItemText } from "@mui/material";
import * as types from "constants/actionTypes";

class ListCheckbox extends Component {
  constructor(props) {
    super(props);
    if (props.value)
      //if store has value relative to this component, initialize the state value
      this.state = { value: props.value, error: "", checked: [] };
    //in case the store does not have any value for this component, just clear it
    else this.state = { value: "", error: "", checked: [] };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectStatus && nextProps.selectStatus == "clear") {
      this.setState({
        checked: [],
      });
      nextProps.callBack();
    } else if (nextProps.selectStatus && nextProps.selectStatus == "all") {
      const myData = this.props.collection;
      var myChecked = [];
      myData.map((item, index) => {
        myChecked.push(item.value);
      });
      this.setState({
        checked: myChecked,
      });
      nextProps.callBack();
    }
  }

  handleToggle = (value) => () => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    this.setState(
      {
        checked: newChecked,
      },
      () => this.updateStore(this.state.checked)
    );
  };

  updateStore(value) {
    this.props.dispatch({
      type: types.FORM_INPUT,
      value,
      name: this.props.name,
    });
  }

  loadList(items) {
    const { width = "25%" } = this.props;
    return items.map((item, index) => (

      <ListItem
        key={index}
        className={this.props.className || "col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"}
        sx={{ padding: 0, width: width }}
        disablePadding
      >
        <Checkbox
          edge="start"
          onChange={this.handleToggle(item.value)}
          checked={this.state.checked.indexOf(item.value) !== -1}
          tabIndex={-1}
        />
        <ListItemText primary={item.text} sx={{
          "& span": {
            fontSize: '13px', fontWeight: 700
          },

        }} />
      </ListItem>
    ));
  }

  // update(it){
  //     console.log(it);
  // }

  // onChange(it){
  //     // console.log(e.target,"kar!");
  //     // console.log(value,"car!");
  //     console.log("karl");
  //     console.log(it);
  // }

  render() {
    const p = this.props;

    return (
      <List name={p.name} className="row m-0">
        {this.loadList(p.collection)}
      </List>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    value: state.form[props.name],
    error: state.form && state.form.error && state.form.error[props.name],
  };
};

export default connect(mapStateToProps)(ListCheckbox);
